import React, { useEffect, useRef, useState } from "react";
import { useGetData, useWindowKey } from "../../hooks";
import { CargoPicker } from "../../components";
import { CircledCrossIcon } from "../../components/icons";

/*   const resetList = () => {
    setDisplayedList([]);
  };
 */

/*   const debouncedChange = debounce((e) => updateQuery(e), 200); */

/*   const { data, getData } = useGetData(); */

function SearchboxLogic(props) {
  const {
    url,
    name,
    list,
    setList,
    Container,
    List,
    Item,
    Button,
    InputContainer,
    Input,
    searchboxIcon,
    cargoPicker,
    setFieldValue,
    inputProps,
    inputStyle,
    value: initialValue = "",
  } = props;
  const [value, setValue] = useState(initialValue);
  const [displayedList, setDisplayedList] = useState(list);
  const [showList, setShowList] = useState(false);
  const listRef = useRef(null);
  const buttonRef = useRef(null);
  const openList = () => setShowList(true);
  const resetValue = () => setValue("");
  const closeList = () => setShowList(false);

  useWindowKey({ keys: ["Escape"], handlers: [closeList] });
  const { text, title, icon } = cargoPicker || {};

  const updateQuery = (e) => {
    const { value } = e.target;
    setValue(value);
    setFieldValue(name, value);

    const formattedValue = value.trim().toLocaleLowerCase();
    if (formattedValue || formattedValue === "") {
      const filteredList = list.filter(({ key }) =>
        key.toLocaleLowerCase().includes(formattedValue)
      );
      return setDisplayedList(filteredList);
    }
    setDisplayedList([]);
  };

  const handleItemBtnClick = (e, key, value) => {
    e.preventDefault();
    console.log("click");
    console.log(key, value);
    setValue(key);
    setFieldValue(name, value);
    closeList();
  };

  const handleFocus = () => {
    openList();
  };

  const handleBlur = (e) => {
    if (
      !buttonRef.current.contains(e.relatedTarget) &&
      !listRef.current.contains(e.relatedTarget)
    )
      closeList();
  };

  const handleCloseButtonBlur = (e) => {
    console.log(buttonRef.current.contains(e.relatedTarget));
    if (buttonRef.current.contains(e.relatedTarget)) return;
    handleBlur(e);
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeList();
    resetValue();
  };
  return (
    <Container style={{ position: "relative" }}>
      {cargoPicker && icon}
      {cargoPicker ? (
        <CargoPicker.ContentInnerWrapper>
          <CargoPicker.Input
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={(e) => updateQuery(e)}
            placeholder={title}
            value={value}
            style={inputStyle}
            {...inputProps}
          />
          <CargoPicker.Text>{text}</CargoPicker.Text>
        </CargoPicker.ContentInnerWrapper>
      ) : (
        <InputContainer>
          <Input onChange={(e) => updateQuery(e)} />
        </InputContainer>
      )}

      {showList && displayedList?.length ? (
        <List ref={listRef}>
          {displayedList.map(({ key, value }) => (
            <Item key={key}>
              <Button onClick={(e) => handleItemBtnClick(e, key, value)}>
                {searchboxIcon ? searchboxIcon : null}
                <p>{key}</p>
              </Button>
            </Item>
          ))}
        </List>
      ) : null}
      {cargoPicker && showList && list?.length ? (
        <CargoPicker.ButtonSmall
          ref={buttonRef}
          onBlur={handleCloseButtonBlur}
          onClick={handleCloseClick}
        >
          <CircledCrossIcon />
        </CargoPicker.ButtonSmall>
      ) : null}
    </Container>
  );
}

export default SearchboxLogic;
